import { AppState } from './state';

export function isLoadingSelector(state: { app: AppState }) {
  return state.app.isLoading;
}

export function viewportWidthSelector(state: { app: AppState }) {
  return state.app.viewportWidth;
}
